import { storageKeys as sandboxStorageKeys } from '@chess-class/sandbox/consts';

export const storageKeys = { ...sandboxStorageKeys };
